export const screenSizes = {
  tablet: 768,
  desktop: 1024,
  smallMobile: 375,
};
